import React from "react";
import { Row } from "../_ui";
import { SITEDETAIL } from "@/constants/testIds";
export default function SeoBrandingPanel({ site, form, setField }) {
  return (
    <>
      <Row label="Publisher name">
        <input
          data-testid={SITEDETAIL.publisherName}
          value={form.publisher_name}
          onChange={(e) => setField("publisher_name", e.target.value)}
          placeholder={site.name}
          className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm"
        />
      </Row>
      <Row label="Publisher logo URL">
        <input
          data-testid={SITEDETAIL.publisherLogoUrl}
          value={form.publisher_logo_url}
          onChange={(e) => setField("publisher_logo_url", e.target.value)}
          placeholder="https://example.com/logo.png"
          className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
      </Row>
      <Row label="Twitter handle">
        <input
          data-testid={SITEDETAIL.twitterHandle}
          value={form.twitter_handle}
          onChange={(e) => setField("twitter_handle", e.target.value)}
          placeholder="@yourbrand"
          className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
      </Row>
      <Row label="GA4 Measurement ID">
        <input
          data-testid={SITEDETAIL.ga4MeasurementId}
          value={form.ga4_measurement_id}
          onChange={(e) => setField("ga4_measurement_id", e.target.value)}
          placeholder="G-XXXXXXXXXX"
          className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
      </Row>

      <div className="pt-6 mt-6 border-t border-zinc-800 label-tiny">AdSense Monetization</div>
      <Row label="Publisher ID">
        <input
          data-testid={SITEDETAIL.adsensePubId}
          value={form.adsense_publisher_id}
          onChange={(e) => setField("adsense_publisher_id", e.target.value)}
          placeholder="ca-pub-1234567890123456"
          className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
      </Row>
      {["header", "in_article", "sidebar", "footer"].map((p) => (
        <Row key={p} label={`Slot · ${p.replace("_", " ")}`}>
          <input
            data-testid={SITEDETAIL.adsenseSlot(p)}
            value={form.adsense_slots[p] || ""}
            onChange={(e) => setField("adsense_slots", { ...form.adsense_slots, [p]: e.target.value })}
            placeholder="numeric slot id"
            className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
          />
        </Row>
      ))}
      <div className="text-[11px] text-zinc-500 mono pl-[200px]">
        Tip: Create slot units in AdSense → Ads → By ad unit. Each placement renders only when both the publisher ID and the slot ID are set.
      </div>
    </>
  );
}
